import React from 'react';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import XIcon from '@mui/icons-material/X';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import YouTubeIcon from '@mui/icons-material/YouTube';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import LanguageIcon from '@mui/icons-material/Language';

const TikTokIcon = (props) => (
    <svg viewBox="0 0 24 24" fill="currentColor" width="1em" height="1em" aria-hidden="true" {...props}>
        <path d="M16.6 5.82A4.28 4.28 0 0 1 15.54 3h-3.09v12.4a2.59 2.59 0 1 1-2.59-2.59c.27 0 .53.04.77.12V9.77a5.68 5.68 0 1 0 4.91 5.63V9.01a7.35 7.35 0 0 0 4.3 1.38V7.3a4.28 4.28 0 0 1-3.24-1.48z" />
    </svg>
);

const SnapchatIcon = (props) => (
    <svg viewBox="0 0 24 24" fill="currentColor" width="1em" height="1em" aria-hidden="true" {...props}>
        <path d="M12.17 2c2.46 0 4.58 1.63 5.19 4.02.2.8.14 1.9.08 2.77l-.02.3c.18.1.46.17.78.08.42-.12.8-.06 1.02.2.24.3.2.72-.2 1.02-.3.22-.72.4-1.18.55-.26.08-.35.25-.26.5.62 1.46 1.62 2.52 3.14 3.06.36.13.44.44.2.73-.44.52-1.3.74-2.08.84-.14.02-.2.1-.23.24-.06.28-.16.6-.5.6-.44 0-.94-.2-1.64-.08-.9.15-1.5.92-2.63 1.4-.66.28-1.3.38-1.94.36-.64.02-1.28-.08-1.94-.36-1.13-.48-1.73-1.25-2.63-1.4-.7-.12-1.2.08-1.64.08-.34 0-.44-.32-.5-.6-.03-.14-.09-.22-.23-.24-.78-.1-1.64-.32-2.08-.84-.24-.29-.16-.6.2-.73 1.52-.54 2.52-1.6 3.14-3.06.09-.25 0-.42-.26-.5-.46-.15-.88-.33-1.18-.55-.4-.3-.44-.72-.2-1.02.22-.26.6-.32 1.02-.2.32.09.6.02.78-.08l-.02-.3c-.06-.87-.12-1.97.08-2.77C7.42 3.63 9.54 2 12 2h.17z" />
    </svg>
);

const ICONS = {
    facebook: FacebookIcon,
    instagram: InstagramIcon,
    x: XIcon,
    linkedin: LinkedInIcon,
    youtube: YouTubeIcon,
    whatsapp: WhatsAppIcon,
    tiktok: TikTokIcon,
    snapchat: SnapchatIcon,
};

/** Icon of a social platform from the dashboard (Social links). */
export default function SocialIcon({ platform, ...props }) {
    const Icon = ICONS[platform] || LanguageIcon;
    return <Icon fontSize="inherit" {...props} />;
}
